import { getUrls, getAuthConfig } from './io';
import { Promise } from 'es6-promise';
import store from '../store/store';
import types from '../store/types';

export class ConfigHelper {

    public static loadAuthenticationSettings(): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            getAuthConfig().then((config) => {
                config.redirectUri = window.location.href;
                resolve(config);
            });
        });

        return promise;
    }

    public static loadUrls(): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            getUrls().then(
                (urls) => {

                    // Store URLS
                    store.dispatch({
                        type: types.SET_URLS,
                        urls: urls
                    });

                    resolve(urls);
                }, reject
            );
        });

        return promise;
    }

}


// WEBPACK FOOTER //
// ./source/ts/helpers/config.ts